export const DEFAULT_PAGE_ID = "home";
